import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBanners } from '../asiosConfig';
import bannerBg from "../images/bannerBG.png";
import { toast } from 'react-toastify';
import { Skeleton } from '@mui/material';

function Header({ scrollToForm }) {
  const [banners, setBanners] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0); // Track active banner index
  const [loading, setLoading] = useState(true);
  const bannerIntervalRef = useRef(null);
  const headerRef = useRef(null);

  // Fetch banners data
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await getBanners();
        if (response.status === 200 || response.status === 201) {
          setBanners(response.data || []);
          setLoading(false);
        } else {
          toast.error(response.data.message);
          setLoading(false);
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        setLoading(false);
      }
    };
    fetchBanner();
  }, []);

  // Automatically switch banners like a slideshow
  useEffect(() => {
    if (banners.length > 0) {
      bannerIntervalRef.current = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % banners.length); // Loop through banners
      }, 3000); // Change every 3 seconds

      return () => clearInterval(bannerIntervalRef.current);
    }
  }, [banners]);

  // Handle button click
  const handleButtonClick = () => {
    clearInterval(bannerIntervalRef.current);
    if (scrollToForm) {
      scrollToForm();
    }
  };

  // Scroll event handler for fixed-top header
  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY > 0) {
          headerRef.current.classList.add('scrolled');
        } else {
          headerRef.current.classList.remove('scrolled');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className='bannerBG'>
      {/* Skeleton for Header Section */}
      {loading ? (
        <Skeleton variant="rectangular" width="100%" height={80} animation="wave" sx={{ backgroundColor: '#e0e0e0' }} />
      ) : (
        <div ref={headerRef} className="fixed-top py-3">
          <div className="container d-flex justify-content-between align-items-between">
            <div className="logo">
              <a href="/">
                <img src="images/logo.png" alt="logo" className="img-fluid" />
              </a>
            </div>
            <div className="accountBtn">
              <Link to="/otpLogin" className="btn loginBtn" onClick={handleButtonClick}>LOGIN</Link>
              <Link to="/" className="btn regBtn" onClick={handleButtonClick}>REGISTER</Link>
            </div>
          </div>
        </div>
      )}

      <div
        style={{
          position: 'relative',
          height: '800px',
          overflow: 'hidden',
        }}
      >
        {/* Skeleton Loader displayed when loading */}
        {loading ? (
          <Skeleton
            variant="rectangular"
            width="100%"
            height="800px"
            animation="wave"
            sx={{ backgroundColor: '#e0e0e0' }} // Optional: customize background color of skeleton
          />
        ) : (
          banners.length > 0 ? (
            banners.map((banner, index) => (
              <div
                key={index}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: `${index === activeIndex ? 0 : 100}%`, // Only show the active banner
                  transition: 'left 1s ease-in-out', // Smooth transition
                  width: '100%',
                  backgroundImage: `url(${banner.media_url || bannerBg})`,
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  height: '800px',
                }}
              >
                <div className="container">
                  <div className="bannerContent text-center">
                    <h1>{banner?.banner_text || 'Default Banner Text'}</h1>
                    <p>{banner?.banner_description || 'Default description goes here'}</p>
                    <Link
                      to={banner?.cta_button_link || '/'}
                      className="btn banBtn"
                      onClick={handleButtonClick}
                      target="_blank"
                    >
                      {banner?.cta_button_text || 'Register Now'}
                    </Link>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                backgroundImage: `url(${bannerBg})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '800px',
              }}
            >
              <div className="container">
                <div className="bannerContent text-center">
                  <h1>Now, chat for free!</h1>
                  <p>Finding your perfect match just became easier</p>
                  <Link to="/" className="btn banBtn" onClick={handleButtonClick}>Register Now</Link>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </header>
  );
}

export default Header;
